<script setup>
import { computed } from 'vue';
import { useFieldErrors } from '@/composables/ruleEngine/useFieldErrors';

const props = defineProps({
    modelValue: { type: Object, default: () => ({}) },
    errors: { type: [Array, Object], default: () => ({}) },
});
const emit = defineEmits(['update:modelValue']);
const { errorsFor } = useFieldErrors(props);

const model = computed({
    get: () => props.modelValue || {},
    set: (val) => emit('update:modelValue', val),
});

const setNumber = (key, value) => {
    emit('touched');
    let finalValue = null;

    if (value !== '' && value !== null) {
        finalValue = Number(value);
    }

    model.value = {
        ...model.value,
        [key]: finalValue,
    };
};

const maxRatio = computed({
    get: () => model.value.max_ratio ?? '',
    set: (val) => setNumber('max_ratio', val),
});
</script>

<template>
<div class="grid md:grid-cols-2 gap-4">
    <StyledInput
        v-model="maxRatio"
        :label="$t('label.tdsr_ratio_value')"
        name="max_ratio"
        type="number"
        :error-messages="errorsFor('max_ratio')" />
</div>
</template>
